var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title1',{attrs:{"type":"1","title":"总有功/无功功率监控"}}),_c('div',{staticStyle:{"width":"560px","height":"300px"}},[(_vm.showcdata)?_c('MyEcharts',{attrs:{"id":'options24h44ours332321332e4333warn1122',"options":_vm.cdata}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }